// Mock data for GREEN ART Landscape & Gardening Services

export const services = [
  {
    id: 1,
    title: "Softscaping",
    description: "Expert planting of trees, shrubs, and grass with native species",
    icon: "Leaf"
  },
  {
    id: 2,
    title: "Hardscaping",
    description: "Patios, walkways, and decorative stone features",
    icon: "Mountain"
  },
  {
    id: 3,
    title: "Landscape Design",
    description: "Complete design and execution of custom landscapes",
    icon: "PenTool"
  },
  {
    id: 4,
    title: "Irrigation Systems",
    description: "Water-saving irrigation network contracting",
    icon: "Droplets"
  },
  {
    id: 5,
    title: "Swimming Pools",
    description: "Design and construction of luxury pools and water features",
    icon: "Waves"
  },
  {
    id: 6,
    title: "Civil Works",
    description: "Comprehensive civil construction services",
    icon: "Building2"
  },
  {
    id: 7,
    title: "Green Houses",
    description: "Professional greenhouse construction and setup",
    icon: "Home"
  },
  {
    id: 8,
    title: "Maintenance",
    description: "Ongoing landscape and garden maintenance services",
    icon: "Wrench"
  }
];

// Projects with actual photos
export const featuredProjects = [
  {
    id: 1,
    title: "Khalifa University - Main Campus",
    client: "Khalifa University",
    category: "Government",
    description: "Complete landscape design and green spaces for the Main Campus student accommodation",
    image: "https://customer-assets.emergentagent.com/job_55c7756f-b73e-4654-b33e-a28bd5ef7fde/artifacts/b7kftclw_image.png"
  },
  {
    id: 2,
    title: "Khalifa University - SAN Campus",
    client: "Khalifa University",
    category: "Government",
    description: "Complete landscape design and green spaces for the SAN Campus student accommodation",
    image: "https://customer-assets.emergentagent.com/job_portfolio-pro-505/artifacts/aaxz3awh_image.png"
  },
  {
    id: 3,
    title: "ALDAR Saadiyat Site Office",
    client: "ALDAR Properties",
    category: "Commercial",
    description: "Complete landscape works including palm trees, native planting, and irrigation for site office facility",
    image: "https://customer-assets.emergentagent.com/job_portfolio-pro-505/artifacts/mmutp0kp_WhatsApp%20Image%202025-11-18%20at%2012.00.43_ca39209d.jpg"
  },
  {
    id: 3,
    title: "Al Khaznah Park",
    client: "Presidential Court",
    category: "Government",
    description: "Complete hardscape & landscaping with jogging track, street lights, play equipment, and grass installation",
    image: "https://customer-assets.emergentagent.com/job_55c7756f-b73e-4654-b33e-a28bd5ef7fde/artifacts/ucwst6th_68c255a7b3ef745dd07567df.jpg"
  },
  {
    id: 4,
    title: "Grand Mosque Ramdan Majles Phase 2",
    client: "Presidential Court",
    category: "Government",
    description: "Irrigation system installation, softscape planting of trees and grass, and planting mounds",
    image: "https://customer-assets.emergentagent.com/job_55c7756f-b73e-4654-b33e-a28bd5ef7fde/artifacts/5m50nius_6832c8b7d80194dd93595b1d.jpg"
  },
  {
    id: 5,
    title: "Joko Widodo Mosque",
    client: "Presidential Court",
    category: "Government",
    description: "Irrigation system installation and softscape planting of trees and shrubs",
    image: "https://customer-assets.emergentagent.com/job_portfolio-pro-505/artifacts/3yunafgb_Joko-Widodo.jpeg"
  }
];

// Additional projects (text-only list)
export const otherProjects = [
  {
    id: 5,
    title: "Al Reeman Phase 11 - 554 Villa Project",
    client: "ALDAR Properties",
    category: "Residential",
    description: "Hardscaping works for 554 villa residential development in Abu Dhabi"
  },
  {
    id: 7,
    title: "Veterinary Clinic",
    client: "Lead Project Management",
    category: "Commercial",
    description: "Complete irrigation system, pump set, and softscape planting for veterinary facility"
  },
  {
    id: 8,
    title: "HDPE Pipes Linear - Avenue Bridge",
    client: "IMKAN Properties",
    category: "Commercial",
    description: "Design and construction of avenue bridge with HDPE pipe linear system"
  },
  {
    id: 9,
    title: "P.295 Saadiyat PMT New Site Office",
    client: "ALDAR",
    category: "Commercial",
    description: "Complete landscape works for new site office development"
  },
  {
    id: 10,
    title: "P.297 Al Raha Water Connection",
    client: "ALDAR Properties",
    category: "Residential",
    description: "Water connection and softscape works for residential development"
  },
  {
    id: 11,
    title: "Changing Room and Swimming Pool",
    client: "ALDAR Projects",
    category: "Residential",
    description: "Construction of changing rooms and swimming pool with complete landscaping"
  }
];

export const certifications = [
  {
    id: 1,
    title: "ISO 9001:2015",
    description: "Quality Management Systems",
    certificateNo: "AAU-10504",
    validUntil: "26 NOV 2025"
  },
  {
    id: 2,
    title: "ISO 14001:2015",
    description: "Environmental Management Systems",
    certificateNo: "AAU-20417",
    validUntil: "26 NOV 2025"
  },
  {
    id: 3,
    title: "ISO 45001:2018",
    description: "Occupational Health and Safety",
    certificateNo: "AAU-30416",
    validUntil: "26 NOV 2025"
  },
  {
    id: 4,
    title: "ICV Certificate",
    description: "In-Country Value",
    certificateNo: "35.04%",
    validUntil: "01 JUN 2026"
  }
];

export const companyInfo = {
  name: "GREEN ART LANDSCAPE & GARDENING SERVICES L.L.C.",
  tagline: "Creating Sustainable Green Spaces in the Desert",
  phone: "+971 2 877 9072",
  email: "info@greenartuae.ae",
  estimationEmail: "estimation@greenartuae.ae",
  website: "www.greenartuae.ae",
  address: "535 Sultan Bin Zayed The First St, Al Danah, Zone 1, Abu Dhabi",
  instagram: "https://www.instagram.com/greenartlandscape.uae",
  location: {
    lat: 24.4887,
    lng: 54.3551
  }
};

export const partners = [
  { id: 1, name: "IMKAN", category: "Developer", logo: "/logos/imkan.png" },
  { id: 2, name: "ALDAR", category: "Developer", logo: "/logos/aldar.png" },
  { id: 3, name: "Presidential Court", category: "Government", logo: "/logos/presidential-court.png" },
  { id: 4, name: "Sheikh Zayed Grand Mosque Centre", category: "Government", logo: "/logos/szgmc.png" },
  { id: 5, name: "Freiburg Contracting", category: "Contractor", logo: "/logos/freiburg.png" },
  { id: 6, name: "United Engineering Construction", category: "Contractor", logo: "/logos/uec.png" },
  { id: 7, name: "Architectural Consulting Group", category: "Consultant", logo: "/logos/acg.png" },
  { id: 8, name: "Agility Engineering & Contracting", category: "Contractor", logo: "/logos/agility.jpg" },
  { id: 9, name: "Masri Engineering & Contracting", category: "Contractor", logo: "/logos/masri.webp" },
  { id: 10, name: "Combined Group Contracting", category: "Contractor", logo: "/logos/cgc.png" },
  { id: 11, name: "Pragma", category: "Consultant", logo: "/logos/pragma.jpeg" },
  { id: 12, name: "Al Ain Consulting Engineers", category: "Consultant", logo: "/logos/ace.png" },
  { id: 13, name: "Parsons", category: "Consultant", logo: "/logos/ad-ports.png" },
  { id: 14, name: "Firas Engineering Consultancy", category: "Consultant", logo: "/logos/ecssr.png" },
  { id: 15, name: "Dar Al Handasah", category: "Consultant", logo: "/logos/al-bayan.png" },
  { id: 16, name: "Hill International", category: "Consultant", logo: "/logos/hill-international.png" },
  { id: 17, name: "Qumra Transport & Contracting", category: "Contractor", logo: "/logos/client-9.webp" },
  { id: 18, name: "Altorath International", category: "Consultant", logo: "/logos/aic.png" },
  { id: 19, name: "Bilfinger Tebodin", category: "Consultant", logo: "/logos/bilfinger-new.jpg" },
  { id: 20, name: "Exceed Industries", category: "Supplier", logo: "/logos/exceed-new.png" },
  { id: 21, name: "Al Bayan Engineers", category: "Consultant", logo: "/logos/al-bayan-new.jpg" },
  { id: 22, name: "Ad Ports Group", category: "Government", logo: "/logos/ad-ports-new.png" },
  { id: 23, name: "ECSSR", category: "Government", logo: "/logos/ecssr-new.png" },
  { id: 24, name: "Lead Project Management", category: "Developer", logo: "/logos/lead-pm-new.png" }
];
